import './EFToastContent.css'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { EFToastContentProps } from './EFToastContent.model'

export function EFToastSuccess(props: EFToastContentProps) {
  return (
    <div className='toast-success'>
      <CheckCircleOutlineIcon
        sx={{ height: 'var(--fs-title-md)', width: 'var(--fs-title-md)' }}
        color='success'
      />
      <span className='toast-message'> {props.text} </span>
    </div>
  )
}
